import { render, staticRenderFns } from "./ModalCompanyAssignment.vue?vue&type=template&id=07ece96e"
import script from "./ModalCompanyAssignment.vue?vue&type=script&lang=js"
export * from "./ModalCompanyAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports